/// <amd-module name="Feed/IvyPromote/Redux/IvyPromote/IvyPromoteActions" />
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

import { IPackageVersion } from "Feed/Core/Types";

export const enum IvyPromoteActionTypes {
    // User Actions
    GetPackageStatus = "Feed/IvyPromote/GetPackageStatus",
    SavePackageStatus = "Feed/IvyPromote/SavePackageStatus",

    // API Actions
    StatusListLoaded = "#api/Feed/IvyPromote/GetStatusList_Completed",
    StatusLoaded = "#api/Feed/IvyPromote/GetPackagePromotionStatus_Completed",
    SaveStarted = "#api/Feed/IvyPromote/SetStatus_Started",
    SaveCompleted = "#api/Feed/IvyPromote/SetStatus_Completed",
    ApiCallFailed = "#api/Feed/IvyPromote/_Failed"
}

export const IvyPromoteActions = {
    // User Actions
    getPackageStatus: (packageObject: IPackageVersion) =>
        createAction(IvyPromoteActionTypes.GetPackageStatus, packageObject),
    savePackageStatus: (packageObject: IPackageVersion, setStatus: string) =>
        trackedAction(createAction(IvyPromoteActionTypes.SavePackageStatus, { packageObject, setStatus })),

    // API Actions
    statusListLoaded: (status: string[]) => createAction(IvyPromoteActionTypes.StatusListLoaded, { status }),
    statusLoaded: (currentStatus: string) => createAction(IvyPromoteActionTypes.StatusLoaded, { currentStatus }),
    saveStarted: () => createAction(IvyPromoteActionTypes.SaveStarted),
    saveCompleted: () => createAction(IvyPromoteActionTypes.SaveCompleted),
    apiCallFailed: (errorMessage: string | undefined) =>
        createAction(IvyPromoteActionTypes.ApiCallFailed, { errorMessage })
};

export type IvyPromoteActions = ActionsUnion<typeof IvyPromoteActions>;
